// packages/ops-platform-v3/src/frontend/expoams/services/index.ts
//
// Singleton barrel for the ExpoAMS frontend services. View components import
// `expoamsClient` from here; they don't construct their own clients or
// IdTokenManagers.
//
// Env vars read at module-load time (Vite inlines these at build time):
//  - VITE_OPS_FUNCTIONS_BASE base for ops-platform-v3 Cloud Functions.
//
// materials-03b Phase 2: `idTokenManager` is the shared singleton from
// `@ams/shared/auth` and is bootstrapped by `App.tsx` via `initAuthSingletons`.
// All other host-side consumers (dataVis, station-data-dashboard) import it
// directly from `@ams/shared/auth` — this barrel does not re-export it.
//
// Plan 10 removed VITE_EXPOAMS_SHEET_IDS — the sheet config is fetched at
// runtime from Firestore via expoamsClient.getSheetConfig().

import { idTokenManager } from '@ams/shared/auth';
import { createExpoAmsClient } from './expoams-client.js';

const FUNCTIONS_BASE = import.meta.env.VITE_OPS_FUNCTIONS_BASE ?? '';

// Plan 16 correction: ExpoAmsClient calls cross-origin Cloud Functions on
// *.cloudfunctions.net — those endpoints are gated by their own ID-token check,
// NOT by internal-auth's CSRF middleware. Sending X-CSRF-Token on those requests
// triggers a CORS preflight that the Functions' CORS config doesn't allow. The
// CSRF header only rides on same-origin /api/** requests (via InternalAuthClient
// and IdTokenManager), not here.
export const expoamsClient = createExpoAmsClient({
  idTokenManager,
  functionsBase: FUNCTIONS_BASE,
});
